import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/FreightTemplates/PackingList/components/SectionAbout/SectionAbout.module.scss';

const cn = classNames.bind(styles);

const SectionAbout = (): ReactElement => {
  return (
    <section className={cn('about')}>
      <div className={cn('container')}>

        <div className={cn('about__description')}>
          <h2 className={cn('about__heading')}>
            What is Packing List?
          </h2>
          <p className={cn('about__paragraph')}>
            It is a precise inventory prepared by the shipper. It lists the net weight, gross weight,
            dimensions, and packaging type for every item in the shipment. Note what’s missing: Price.
            The warehouse guy operating the forklift doesn't need to know the dollar value of the goods;
            he needs to know if the pallet is heavy, fragile, or stackable. That’s what the packing list is for.
          </p>
          <div className={cn('about__buttons')}>
            <a
              className={cn('about__button-download-word')}
              href='/download/Resources/FreightTemplates/packing_list.docx'
              target='_blank'
            >
              Download (Word)
            </a>
            <a
              className={cn('about__button-download-pdf')}
              href='/download/Resources/FreightTemplates/packing_list.pdf'
              target='_blank'
            >
              Download (pdf)
            </a>
          </div>
        </div>

        {/* TODO: uncomment when picture is provided */}
        {/* <div className={cn('about__image-container')}>
          <picture>
            <source
              srcSet="/images/pages/Resources/FreightTemplates/BillOfLading/template@2x.webp 2x, 
                      /images/pages/Resources/FreightTemplates/BillOfLading/template.webp 1x"
              sizes="100vw"
            />
            <img
              className={cn('about__image')}
              src="/images/pages/Resources/FreightTemplates/BillOfLading/template.webp"
              alt="template"
            />
          </picture>
        </div> */}

      </div>
    </section>
  );
};

export default SectionAbout;